module.exports = __webpack_public_path__ + "media/images/trailmaker/release-empty-f1c9e426b2e06b027bc24d9647df20db.svg";